



































































































































































































































import { Component, Mixins, Watch } from 'vue-property-decorator'
import VueRouter from 'vue-router'
import GlobalMixin, {ALERT_TYPE} from '@/mixins/globalMixin'
import LoadingComponent from '@/components/LoadingComponent.vue'
import AlertBarComponent from '@/components/AlertBarComponent.vue'
import BreadcrumbsComponent from '@/components/BreadcrumbsComponent.vue'
import SelectDaysComponent from '@/components/SelectDaysComponent.vue'
import CustomerSelectDialogComponent from '@/components/CustomerSelectDialogComponent.vue'
import PdfViewComponent from '@/components/PdfViewComponent.vue'
import SendMailDialogComponent from '@/components/SendMailDialogComponent.vue'
import { Confirmation, MailQueue } from '@/domain/Confirmation'
import { SendMail } from '@/domain/SendMail'
import { WindowPosition } from '@/domain/WindowPosition'
import ConfirmationsService, { SerchConditon } from '@/service/ConfirmationsService'

@Component({
  components: {
    LoadingComponent,
    AlertBarComponent,
    BreadcrumbsComponent,
    SelectDaysComponent,
    CustomerSelectDialogComponent,
    PdfViewComponent,
    SendMailDialogComponent,
  },
})
export default class MemberConfirmationList extends Mixins(GlobalMixin) {
  confirmationsService = ConfirmationsService.instance

  /** 検索条件 */
  conditions = new SerchConditon()
  /** データテーブル ヘッダー設定 */
  searchFilter = ""
  headers = [
          { text: "発行日", value: "confirmationOn", width: "100px" },
          { text: "請書番号", value: "confirmationNo", width: "130px" },
          { text: "納品予定日", value: "deliveryOn", width: "110px" },
          { text: "顧客名", value: "customerInfo.customerName", width: "240px" },
          { text: "検体識別記号", value: "specimenIds", width: "130px" },
          { text: "検査項目", value: "sumInfo.inspectionNames" },
          { text: "小計", value: "sumInfo.amount", align: "end", filterable: false, width: "100px" },
          { text: "消費税", value: "sumInfo.tax", align: "end", filterable: false, width: "100px" },
          { text: "見積金額", value: "sumInfo.totalAmount", align: "end", filterable: false, width: "100px" },
          { text: "印刷", value: "printAt", align: "center", filterable: false, width: "80px" },
          { text: "メール", value: "mailSendAt", align: "center", filterable: false, width: "100px" },
          { text: "他文書", value: "links", filterable: false, sortable: false, width: "50px"  },
          { text: "操作", value: "actions", filterable: false, sortable: false, width: "160px" },
  ]
  list: Confirmation[] = []
  selectItems: Confirmation[] = []
  rowItemKey = ""
  rowItemClickTime = 0
  customerName = ""
  mailSendConfirmationNos: string[] = []
  sendMail = new SendMail()

  /**
   * 選択リストのバリデーション
   */
  get isValidate() {
    const keys = this.selectItems.map(x => `${x.customerInfo.customerPrefectureCode}:${x.customerInfo.customerCode}:${x.customerInfo.customerBranchNumber}:${x.agencyInfo.agencyPrefectureCode}:${x.agencyInfo.agencyCode}:${x.agencyInfo.agencyBranchNumber}:${x.requestType}`)
    const distinct = [...new Set(keys)]
    return distinct.length === 1
  }

  /**
   * 初期実行
   */
  mounted() {
    /* 初期検索 */  
    const conditions = sessionStorage.getItem("tool.confirmation.list.conditions")
    if (conditions !== null) {
      this.conditions = JSON.parse(conditions) as SerchConditon
    }
    const searchFilter = sessionStorage.getItem("tool.confirmation.list.searchFilter")
    if (searchFilter !== null) {
      this.searchFilter = searchFilter
    }
    this.search()
  }

  /**
   * 検索処理
   */
  search() {
    this.showLoading()
    sessionStorage.setItem("tool.confirmation.list.conditions", JSON.stringify(this.conditions))
    this.confirmationsService.findAll(this.conditions)
      .then(x => {
        this.list = x
        this.selectItems = []
        this.mountedDataTable("tool.confirmation.list")
        this.hideLoading()
      })
      .catch(error => {
        // eslint-disable-next-line
        console.log(error)
        this.alert("検索エラー", ALERT_TYPE.ERROR)
        this.hideLoading()
      })
  }

  /**
   * フィルター処理
   */
  // eslint-disable-next-line
  customFilter(value: any, search: string | null, item: Confirmation): boolean {
    return this.filterCompare(search, item.filterKeyword)
  }

  /**
   * 行クリック時の処理
   */
  onClickRow(event: Confirmation) {
    const now = (new Date()).getTime()
    if ((now - this.rowItemClickTime) <= 500 && this.rowItemKey === event.confirmationNo) {
      this.$router.push(`/member/confirmation/edit/${event.confirmationNo}`)
    }
    this.rowItemKey = event.confirmationNo
    this.rowItemClickTime = now
  }
  /**
   * 印刷ボタンのクリック
   */
  onPrint(confirmationNo: string) {
    this.confirmationsService.print(confirmationNo)
      .then(dto => {
        this.list.filter(x => x.confirmationNo === confirmationNo)
            .forEach(x => x.printAt = dto.printAt)
        this.openPdfViewDialog("請書印刷", dto.confirmationFile.content)
      })
  }

  /**
   * メール一括送信ボタンのクリック
   */
  onMail() {
    const confirmationNos = this.selectItems.map(x => x.confirmationNo)
    this.onSendMail(confirmationNos)
  }

  /**
   * メール送信ボタンのクリック
   */
  onSendMail(confirmationNos: string[]) {
    this.mailSendConfirmationNos = confirmationNos
    this.confirmationsService.generateMailTemplate(this.mailSendConfirmationNos)
      .then(x => {
        this.sendMail = x
        this.mailSendDialog = true
      })
      .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
          this.alert("メール送信テンプレートの取得に失敗しました", ALERT_TYPE.ERROR)
          this.hideLoading()
      })
  }

  /**
   * メール送信
   */
  onSendMailed(event: SendMail) {
    this.showLoading()
    const mailQueue = new MailQueue({to: event.to, cc: event.cc, bcc: event.bcc, replyTo: event.replyTo, subject: event.subject, content: event.content, confirmationNos: this.mailSendConfirmationNos})
    this.confirmationsService.mailQueuePush(mailQueue)
      .then((x) => {
          this.list.filter(y => mailQueue.confirmationNos.indexOf(y.confirmationNo) >= 0)
            .forEach(y => y.mailSendAt = x.mailSendAt)
          this.alert("メール送信しました", ALERT_TYPE.SUCCESS)
          this.hideLoading()
      })
      .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
          this.alert("メール送信に失敗しました", ALERT_TYPE.ERROR)
          this.hideLoading()
      })
  }

  /**
   * フィルター変更
   */
  @Watch("searchFilter")
  changeSearchFilter() {
    sessionStorage.setItem("tool.confirmation.list.searchFilter", this.searchFilter)
  }

  /**
   * 画面を遷移する前の状態保存
   */
  // eslint-disable-next-line
  beforeRouteLeave(to: VueRouter, from: VueRouter, next: any) {
    sessionStorage.setItem("tool.confirmation.list.dataTableOptions", JSON.stringify(this.dataTableOptions))
    sessionStorage.setItem("tool.confirmation.list.windowPosition", JSON.stringify(WindowPosition.now()))
    next()
  }
}
